import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Programs', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Location', path: '/location' },
  { label: 'Contact', path: '/contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled || mobileOpen
          ? 'bg-charcoal shadow-lg py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 group cursor-pointer">
          <div className="w-9 h-9 flex items-center justify-center bg-gold rounded-md shrink-0">
            <span className="font-playfair font-bold text-charcoal text-sm">OC</span>
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-playfair font-bold text-[15px] text-white tracking-wide">OST-C</span>
            <span className="text-gold text-[9px] font-inter font-medium tracking-[0.18em] uppercase">
              Occupational Skills Training
            </span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-inter text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === link.path
                  ? 'text-gold'
                  : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Desktop CTAs */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:4698535038"
            className="flex items-center gap-2 text-white/80 hover:text-gold transition-colors duration-200 font-inter text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-gold text-base" />
            469-853-5038
          </a>
          <Link
            to="/contact"
            className="bg-gold hover:bg-gold-dark text-charcoal font-inter font-bold text-sm px-5 py-2.5 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Enroll Now
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-charcoal border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-inter text-base font-medium cursor-pointer ${
                location.pathname === link.path ? 'text-gold' : 'text-white/80'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="pt-3 border-t border-white/10 flex flex-col gap-3">
            <a
              href="tel:4698535038"
              className="flex items-center gap-2 text-white/80 font-inter text-sm cursor-pointer"
            >
              <i className="ri-phone-line text-gold" />
              469-853-5038
            </a>
            <Link
              to="/contact"
              className="bg-gold text-charcoal font-bold text-sm px-5 py-3 rounded-md text-center whitespace-nowrap cursor-pointer"
            >
              Enroll Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
